module.exports = __webpack_public_path__ + "img/list2.56d223e0.png";